import { Button, Dropdown, Menu } from '@zenlayer/zen-design';
import { ButtonProps } from '@zenlayer/zen-design/esm/button';
import t, { getLocale, Locales, setLocale } from '@zenlayer/zen-intl18';
import * as React from 'react';

const LanguageButton: React.FC<ButtonProps> = (props) => {
  const currentLocale = getLocale();
  const text = {
    en: t('odj6ymtWxcwR'),
    zh: t('n7DIVs3ZpxSk'),
  }[currentLocale];

  return (
    <Dropdown
      dropdownRender={() => (
        <Menu
          onClick={({ key }) => {
            key !== currentLocale && setLocale(key as Locales);
            location.reload();
          }}
          selectedKeys={[currentLocale]}
          items={[
            { key: 'en', label: 'English' },
            { key: 'zh', label: '中文' },
          ]}
        />
      )}
    >
      <Button type="text" size="s" textBaseColor {...props}>
        {text}
      </Button>
    </Dropdown>
  );
};

export default LanguageButton;
